import AddGroupTab from "./sub_tabs/AddGroupTab";
import RecallGroupsTab from "./sub_tabs/RecallGroupsTab";
import ViewRecalleesTab from "./sub_tabs/ViewRecalleesTab";

const recallsRouter = {

  groupings: 
  {
    title: 'Groups',
    element: <RecallGroupsTab />
  },

  create_group: 
  {
    title: 'Create Group',
    element: <AddGroupTab />
  },

  recallees_list: 
  {
    title: 'List',
    element: <ViewRecalleesTab />
  }

}

export default recallsRouter;